// src/components/EventList.js
import EventCard from "./EventCard";
import SpinnerOverlay from "./SpinnerOverlay";

/* eslint-disable react/prop-types */
export const EventList = ({events, error, loading}) => {


    // Mostrar mensaje de carga mientras se obtiene el evento
    if (loading) {
        return <SpinnerOverlay isLoading={loading} />;
    }

    if (events.length < 1 || error){
        return (
            <section className="mx-auto my-12 flex min-h-[45vh] w-full max-w-3xl items-center justify-center px-4">
                <div className="w-full rounded-2xl border border-zinc-800 bg-zinc-900/60 p-8 text-center shadow-[0_0_0_1px_rgba(255,255,255,0.02),0_20px_60px_rgba(0,0,0,0.35)] backdrop-blur-sm">
                    <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-zinc-800 text-yellow-cdg">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            className="h-7 w-7"
                            aria-hidden="true"
                        >
                            <path d="M3 9a2 2 0 0 0 2-2h14a2 2 0 0 0 2 2v2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2H5a2 2 0 0 0-2-2v-2a2 2 0 0 0 2-2V9Z" />
                            <path d="M12 7v10" />
                        </svg>
                    </div>
                    <h3 className="text-2xl font-bold text-white">
                        No hay eventos disponibles por ahora
                    </h3>
                    <p className="mx-auto mt-3 max-w-xl text-zinc-300">
                        Estamos preparando nuevas fechas. Volvé pronto para descubrir los próximos eventos.
                    </p>
                </div>
            </section>
        );
    }

    return (
        <>
            <SpinnerOverlay isLoading={loading} />
            <div className="my-4 flex flex-wrap justify-center gap-7 px-4 pb-8">
                {events.map((event) => (
                    <EventCard key={event.uniqueId || event.id || event.slug} event={event} />
                ))}
            </div>
        </>
    );
};

export default EventList;
